<template>
  <div id="integrationsHRIS" class="margin-subpages">
    <div id="selectSyncMethod" class="mb-32">
      <div class="sub-title">{{ $t('integrations.SELECT_SYNC_METHOD') }}</div>
      <div class="line-style my-16" />
      <div class="flex-row-between mt-14">
        <div style="width: 320px;">
          <el-menu class="input-select" mode="horizontal">
            <el-submenu index="0" style="width: 320px;">
              <template slot="title">
                <span class="text-dropdown" id="hrisMethod">{{ $t('integrations.Webhook') }}</span>
              </template>
              <el-menu-item
                index="2"
                @click="sortBy('Webhook')"
                style="font-size: 14px;width: 320px;"
              >{{ $t('integrations.Webhook') }}</el-menu-item>
              <el-menu-item
                v-if="hasDirectorySyncSettings"
                index="3"
                @click="sortBy('Directory_Sync')"
                style="font-size: 14px;width: 320px;"
              >{{ $t('integrations.Directory_Sync') }}</el-menu-item>
              <el-menu-item
                index="1"
                @click="sortBy('name')"
                style="font-size: 14px;width: 320px;"
              >{{ $t('integrations.Sort_by_Name') }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
    <div>
      <div v-if="syncType == 'Webhook' || syncType == 'name'" id="integratioParameter">
        <div class="sub-title">{{ $t('integrations.INTEGRATION_PARAMETERS') }}</div>
        <div class="line-style mt-16 mb-28" />
        <div class="grid-2-parameter">
          <div class="title flex-center" style="justify-content: flex-end;">{{ $t('integrations.Webhook_Endpoint') }}</div>
          <div class="flex-center">
            <el-input placeholder="URL" class="input" v-model="dataSettings.webhook" disabled></el-input>
            <input type="hidden" id="webhookEndpointHiden" :value="dataSettings.webhook" />
            <el-button
              icon="el-icon-copy-document"
              class="refersh"
              @click.prevent="copyTestingCode('webhook')"
            ></el-button>
          </div>
          <div class="title flex-center" style="justify-content: flex-end;">{{ $t('integrations.Token') }}</div>
          <div class="flex-center">
            <el-input placeholder="URL" class="input" v-model="dataSettings.token_temp" disabled></el-input>
            <input type="hidden" id="tokenHiden" :value="dataSettings.token_temp" />
            <el-button
              icon="el-icon-copy-document"
              class="refersh"
              @click.prevent="copyTestingCode('token')"
            ></el-button>
            <el-button icon="el-icon-refresh-right" class="refersh" @click="generateTokenFunc"></el-button>
          </div>
          <div class="title right pt-32" style="justify-content: flex-end;">{{ $t('integrations.Sync_Type') }}</div>
          <div class="mt-30">
            <el-radio-group v-model="dataSettings.sync_type">
              <el-radio label="staged">
                <span class="fc-3B3B3B fs-18">{{ $t('integrations.Staged_Syncing') }}</span>
              </el-radio>
              <div
                class="pl-40 fc-3B3B3B fs-14 mb-5 opa-07"
                style="width: 580px; margin-top: -2px;"
              >{{ $t('integrations.Your_members_are_queued_up') }}</div>
              <el-radio label="normal">
                <span class="fc-3B3B3B fs-18">{{ $t('integrations.Normal_Syncing') }}</span>
              </el-radio>
              <div
                class="pl-40 fc-3B3B3B fs-14 mb-5 opa-07"
                style="width: 580px; margin-top: -2px;"
              >{{ $t('integrations.Users_can_be_added') }}</div>
              <el-radio label="onetoone">
                <span class="fc-3B3B3B fs-18">1:1 {{ $t('integrations.Syncing') }}</span>
              </el-radio>
              <div
                class="pl-40 fc-3B3B3B fs-14 mb-12 opa-07"
                style="width: 580px; margin-top: -2px;"
              >{{ $t('integrations.All_users_who_are') }}</div>
            </el-radio-group>
          </div>
          <div class="title right pt-3" style="justify-content: flex-end;">{{ $t('integrations.Options') }}</div>
          <div>
            <template>
              <el-checkbox
                v-model="dataSettings.abbreviate_team_name"
                @change="showingConfirm"
              >{{ $t('integrations.Abbreviate_Team_Name') }}</el-checkbox>
            </template>
            <div
              class="pl-40 fc-3B3B3B fs-14 mb-8 opa-07"
              style="width: 580px; margin-top: -2px;"
            >{{ $t('integrations.Automatically_abbreviate_long_team') }}</div>
          </div>
          <div class="title right pt-3" style="justify-content: flex-end;">{{ $t('integrations.Enable') }}</div>
          <div>
            <template>
              <el-checkbox v-model="dataSettings.live">{{ $t('integrations.Enable_web_hook') }}</el-checkbox>
            </template>
            <div
              class="pl-40 fc-3B3B3B fs-14 mb-8 opa-07"
              style="width: 580px; margin-top: -2px;"
            >{{ $t('integrations.Any_data_that') }}</div>
          </div>
          <div></div>
          <el-button class="save" @click="saveChanges">{{ $t('integrations.Save_Changes') }}</el-button>
        </div>
      </div>
      <div v-else-if="syncType == 'Directory_Sync'" id="integratioParameter">
        <div class="sub-title">{{ $t('integrations.INTEGRATION_PARAMETERS') }}</div>
        <div class="line-style mt-16 mb-28" />
        <div class="grid-2-parameter">
          <div class="title flex-center" style="justify-content: flex-end;">{{ $t('integrations.Endpoint') }}</div>
          <div class="flex-center">
            <el-input placeholder="URL" class="input" v-model="directorySyncSettings.endpoint" disabled></el-input>
            <input type="hidden" id="webhookEndpointHiden" :value="directorySyncSettings.endpoint" />
            <el-button
              icon="el-icon-copy-document"
              class="refersh"
              @click.prevent="copyTestingCode('webhook')"
            ></el-button>
          </div>
          <div class="title flex-center" style="justify-content: flex-end;">{{ $t('integrations.Token') }}</div>
          <div class="flex-center">
            <el-input placeholder="URL" class="input" v-model="directorySyncSettings.token" disabled></el-input>
            <input type="hidden" id="tokenHiden" :value="directorySyncSettings.token" />
            <el-button
              icon="el-icon-copy-document"
              class="refersh"
              @click.prevent="copyTestingCode('token')"
            ></el-button>
            <el-button icon="el-icon-refresh-right" class="refersh" @click="generateTokenFunc"></el-button>
          </div>
          <div class="title right pt-32" style="justify-content: flex-end;">{{ $t('integrations.Sync_Type') }}</div>
          <div class="mt-30">
            <el-radio-group v-model="directorySyncSettings.sync_type">
              <el-radio label="staged">
                <span class="fc-3B3B3B fs-18">{{ $t('integrations.Staged_Syncing') }}</span>
              </el-radio>
              <div
                class="pl-40 fc-3B3B3B fs-14 mb-5 opa-07"
                style="width: 580px; margin-top: -2px;"
              >{{ $t('integrations.Your_members_are_queued_up') }}</div>
            </el-radio-group>
          </div>
          <div class="title right pt-3" style="justify-content: flex-end;">{{ $t('integrations.Enable') }}</div>
          <div>
            <template>
              <el-checkbox v-model="directorySyncSettings.live">{{ $t('integrations.Enable_Directory_Sync') }}</el-checkbox>
            </template>
            <div
              class="pl-40 fc-3B3B3B fs-14 mb-8 opa-07"
              style="width: 580px; margin-top: -2px;"
            >{{ $t('integrations.Directory_Sync_Desc') }}</div>
          </div>
          <div></div>
          <el-button class="save" @click="saveChanges">{{ $t('integrations.Save_Changes') }}</el-button>
        </div>
      </div>
      <div id="webhookLogs" class="mb-40 pb-40">
        <div class="sub-title">{{ $t('integrations.WEBHOOK_LOGS') }}</div>
        <div class="line-style mt-28 mb-16" />
        <div class="fc-3B3B3B fs-14">
          {{ $t('integrations.Sync_users_using_your') }}
          <span class="fw-700">{{ $t('integrations.Simulate_Changes') }}</span> 
          {{ $t('integrations.to_see_how_the') }}
        </div>
        <div style="min-height: 200px;">
          <div class="grid-4-log-table mt-24">
            <div class="title">{{ $t('integrations.Date') }}</div>
            <div class="title">{{ $t('integrations.Webhook_Content') }}</div>
            <div class="title">{{ $t('integrations.Integration_Status') }}</div>
            <div class="title">{{ $t('integrations.Actions') }}</div>
          </div>
          <div v-for="item in dataSettings['webhook_logs']" :key="item.key">
            <div class="grid-4-log-table mt-24">
              <div class="date">
                <div>{{item.parse_date}}</div>
                <div>{{ item.parse_time }}</div>
              </div>
              <div class="content thin-scrollbar">
                {{ item.content }}
              </div>
              <div class="integration-status">{{ item.live ? "Live" : "Test Mode" }}</div>
              <div class="actions">
                <el-button
                  v-if="item.live"
                  class="btn-gray-outline"
                  @click.prevent="viewChangesModalStatus = !viewChangesModalStatus"
                  @click="viewChangeModalClick(item)"
                >{{ $t('integrations.View_Changes') }}</el-button>
                <el-button
                  v-else
                  class="btn-gray-outline"
                  @click.prevent="simulateChangesModalStatus = !simulateChangesModalStatus"
                  @click="simulateChangeModalClick(item)"
                >{{ $t('integrations.Simulate_Changes') }}</el-button>
              </div>
            </div>
          </div>
          <div
            v-if="dataSettings['webhook_logs'].length == 0"
            class="opa-06 center py-40 fs-14"
            style="padding-top: 60px;"
          >
            {{ $t('integrations.No_webhook_activity') }}
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="viewChangesModalStatus" top="8vh" id="viewChangesModal">
        <div class="fc-2D2E36 fs-24 fw-700">{{ $t('integrations.View_Changes') }}</div>
        <div class="pl-40 mt-36">
          <span class="fs-24 fw-900">{{ (resultsView.length > 0) ? $utils('addCommasInNumber', resultsView.length) : 0 }}</span>
          <span class="fs-24 fw-700">&nbsp;{{ $t('integrations.Members') }}</span>
        <div class="flex-row-between mt-25">
            <el-input
              class="input-style"
              style="height: 40px;"
              autosize
              :placeholder="$t('global.Search')"
              v-model="inputSearchView"
              clearable
            ></el-input>
          </div>
          <div class="mt-10">
            <el-table
              ref="multipleTable"
              :data="membersView"
              style="width: 100%;"
              :empty-text="loadingViewTable ? ' ' : !membersView && inputSearchView === '' ? 'No view change' : 'No results found...'"
              @sort-change="sortView"
            >
              <el-table-column width="42">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img
                        v-if="scope.row.pic"
                        v-lazy="scope.row.pic"
                        :key="scope.row.pic"
                        class="image-skeleton image-profile-42 flex-mid mx-10"
                    />
                    <div v-else class="image image-profile-42 flex-mid">
                      <div
                        class="text-in-image text-in-image-42 flex-mid"
                      >{{ $utils('acronymName', {firstName: scope.row.firstname, lastName: scope.row.lastname}) }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" sortable="custom" label="Member" width="170">
                <template slot-scope="scope">
                  <div class="flex-column ml-6 my-1">
                    <span class="text-email">{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="email" sortable="custom" label="Email Address" width="190">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="text-email">{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="team_name" sortable="custom" label="Team" width="120">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="fs-14 fc-#4A4A4A">{{ scope.row.team_name }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="boss_name" sortable="custom" label="Manager" width="170">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="fs-14 fc-#4A4A4A">{{ scope.row.boss_name }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="start_date_format" sortable="custom" label="Start Date" width="140">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="fs-14 fc-#4A4A4A">{{ scope.row.start_date }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="change_type" sortable="custom" label="Change" width="140">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="fs-14 fc-#4A4A4A">{{ scope.row.change_type }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="center mt-10 mb-40 pt-10 pb-40" v-if="loadingViewTable">
              <loading-even></loading-even>
            </div>
            <div class="flex-center pagination mt-10">
              <el-pagination
                @current-change="handleViewCurrentChange"
                :current-page="pageview"
                :page-size="10"
                :pager-count="5"
                layout="prev, pager, next"
                :total="resultsView.length"
              ></el-pagination>
              <span class="results-status">
                {{(resultsView.length > 10) ? 10 : resultsView.length }} {{ $t('integrations.results_from') }} {{ $utils('addCommasInNumber', resultsView.length) }} results
              </span>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="simulateChangesModalStatus" top="8vh" id="simulateChangesModal">
        <div class="fc-2D2E36 fs-24 fw-700">{{ $t('integrations.Simulate_Changes') }}</div>
        <div class="pl-40 mt-36">
          <span class="fs-24 fw-900">{{ (resultsSimulate.length > 0) ? $utils('addCommasInNumber', resultsSimulate.length) : 0 }}</span>
          <span class="fs-24 fw-700">&nbsp;{{ $t('integrations.Members') }}</span>
          <div class="flex-row-between mt-25">
            <el-input
              class="input-style"
              style="height: 40px;"
              autosize
              :placeholder="$t('global.Search')"
              v-model="inputSearchSimulate"
              clearable
            ></el-input>
          </div>
          <div class="mt-10">
            <el-table
              ref="multipleTable"
              :data="membersSimulate"
              style="width: 100%;"
              :empty-text="loadingSimulateTable ? ' ' : !membersSimulate && inputSearchSimulate === '' ? 'No simulate change' : 'No results found...'"
              @sort-change="sortSimulate"
            >
              <el-table-column width="42">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img
                        v-if="scope.row.pic"
                        v-lazy="scope.row.pic"
                        :key="scope.row.pic"
                        class="image-skeleton image-profile-42 flex-mid mx-10"
                    />
                    <div v-else class="image image-profile-42 flex-mid">
                      <div
                        class="text-in-image text-in-image-42 flex-mid"
                      >{{ $utils('acronymName', {firstName: scope.row.firstname, lastName: scope.row.lastname}) }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" sortable="custom" label="Member" width="170">
                <template slot-scope="scope">
                  <div class="flex-column ml-6 my-1">
                    <span class="text-name">{{ scope.row.firstname }} {{ scope.row.lastname }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="email" sortable="custom" label="Email Address" width="190">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="text-email">{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="team_name" sortable="custom" label="Team" width="120">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="fs-14 fc-#4A4A4A">{{ scope.row.team_name }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="boss_name" sortable="custom" label="Manager" width="170">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="fs-14 fc-#4A4A4A">{{ scope.row.boss_name }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="start_date_format" sortable="custom" label="Start Date" width="140">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="fs-14 fc-#4A4A4A">{{ scope.row.start_date }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="change_type" sortable="custom" label="Change" width="140">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="fs-14 fc-#4A4A4A">{{ scope.row.change_type }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="center mt-10 mb-40 pt-10 pb-40" v-if="loadingSimulateTable">
              <loading-even></loading-even>
            </div>
            <div class="flex-center pagination mt-10">
              <el-pagination
                @current-change="handleSimulateCurrentChange"
                :current-page="pagesimulate"
                :page-size="10"
                :pager-count="5"
                layout="prev, pager, next"
                :total="resultsSimulate.length"
              ></el-pagination>
              <span class="results-status">
                {{(resultsSimulate.length > 10) ? 10 : resultsSimulate.length }} {{ $t('integrations.results_from') }} {{ $utils('addCommasInNumber', resultsSimulate.length) }} results
              </span>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "overview",
  components: {
    loadingEven: require("../even/loading").default,
  },
  created() {
    this.$store.dispatch("integrations/getDataIntregrationSetting", this.user);
    this.$store.commit("authen/setActiveIndex", "2");
  },
  watch: {
    inputSearchSimulate() {
      this.$store.dispatch(
        "integrations/searchMembersSimulate",
        this.inputSearchSimulate
      );
    },
    inputSearchView() {
      this.$store.dispatch(
        "integrations/searchMembersView",
        this.inputSearchView
      );
    },
  },
  computed: {
    inputSearchSimulate: {
      get() {
        return this.$store.getters["integrations/inputSearchSimulate"];
      },
      set(value) {
        this.$store.commit("integrations/setinputSearchSimulate", {
          keyword: value
        });
      }
    },
    inputSearchView: {
      get() {
        return this.$store.getters["integrations/inputSearchView"];
      },
      set(value) {
        this.$store.commit("integrations/setinputSearchView", {
          keyword: value
        });
      }
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    dataSettings() {
      return this.$store.getters["integrations/dataSettings"];
    },
    directorySyncSettings() {
      return this.$store.getters["integrations/directorySyncSettings"];
    },
    hasDirectorySyncSettings() {
      return this.$store.getters["integrations/hasDirectorySyncSettings"];
    },
    resultsSimulate() {
      return this.$store.getters["integrations/resultsSimulate"];
    },
    membersSimulate() {
      return this.$store.getters["integrations/membersSimulate"];
    },
    membersSimulateAll() {
      return this.$store.getters["integrations/membersSimulateAll"];
    },
    loadingSimulateTable() {
      return this.$store.getters["integrations/loadingSimulateTable"];
    },
    pagesimulate() {
      return this.$store.getters["integrations/pagesimulate"];
    },
    resultsView() {
      return this.$store.getters["integrations/resultsView"];
    },
    membersView() {
      return this.$store.getters["integrations/membersView"];
    },
    membersViewAll() {
      return this.$store.getters["integrations/membersViewAll"];
    },
    loadingViewTable() {
      return this.$store.getters["integrations/loadingViewTable"];
    },
    pageview() {
      return this.$store.getters["integrations/pageview"];
    },
  },
  data() {
    return {
      webhookEndpoint:
        "https://app.happily.ai/hriswebhook/e91823kdkd102123/1292923181",
      token: null,
      syncType: "Webhook",
      enableWebHook: false,
      viewChangesModalStatus: false,
      simulateChangesModalStatus: false,
    };
  },
  methods: {
    saveChanges() {
      var messageLoading = this.$message({
        type: "warning",
        message: "Saving changes...",
        duration: "9999000"
      });
      this.$store.dispatch("integrations/saveChanges", {
        form: this.dataSettings,
        thisvue: this,
        messageLoading: messageLoading
      });
    },
    sortBy(type) {
      if (type == "name") {
        document.getElementById("hrisMethod").innerHTML = "Sort by Name";
      } else if (type == "Webhook") {
        document.getElementById("hrisMethod").innerHTML = "Webhook";
      } else if (type == "Directory_Sync") {
        document.getElementById("hrisMethod").innerHTML = "Directory Sync";
      }
      this.syncType = type;
    },
    generateTokenFunc() {
      this.$store.commit("integrations/settokenTemp");
    },
    copyTestingCode(input) {
      let value;
      if (input === "token") {
        value = document.querySelector("#tokenHiden");
      } else if (input === "webhook") {
        value = document.querySelector("#webhookEndpointHiden");
      }
      value.setAttribute("type", "text");
      value.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "Copy successful." : "Copy unsuccessful.";
        this.$message({
          message: msg,
          type: "success"
        });
      } catch (err) {
        this.$message.error("Oops, unable to copy");
      }
      value.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    showingConfirm(value) {
      this.$confirm(
        "Changing this setting after your integration has already gone live will cause your existing team names to irreversibly change. You may lose historical data associated with affected teams. Are you sure you would like to proceed?",
        "Warning",
        {
          confirmButtonText: "Proceed",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$message({
            type: "success",
            message: "Option will take affect upon saving changes"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Option change cancelled"
          });
          this.dataSettings.abbreviate_team_name = !value;
        });
    },
    simulateChangeModalClick(item){
      this.$store.dispatch("integrations/getSimulateData", item);
    },
    viewChangeModalClick(item){
      this.$store.dispatch("integrations/getViewData", item);
    },
    sortSimulate({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("integrations/sortMemberSimulate", [
          column.property,
          order
        ]);
      }
    },
    handleSimulateCurrentChange(val) {
      this.$store.dispatch("integrations/simulateCurrentChange", val);
    },
    sortView({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("integrations/sortMemberView", [
          column.property,
          order
        ]);
      }
    },
    handleViewCurrentChange(val) {
      this.$store.dispatch("integrations/viewCurrentChange", val);
    },
  }
};
</script>

<style lang="scss" scoped>
.grid-2-parameter {
  display: grid;
  grid-template-columns: 240px auto;
  grid-row-gap: 16px;
  row-gap: 16px;
  .title {
    font-weight: 700;
    font-size: 18px;
    color: #4a4a4a;
    margin-right: 24px;
  }
}
.grid-4-log-table {
  display: grid;
  grid-template-columns: 140px calc(100% - (40px * 3 + 140px + 150px + 160px)) 150px 160px;
  grid-column-gap: 40px;
  column-gap: 40px;
  color: #4a4a4a;
  .title {
    color: #2e2e2e;
    font-size: 14px;
    font-weight: 700;
  }
  .date {
    font-size: 14px;
    div:first-child {
      font-weight: 700;
    }
  }
  .content {
    word-break: break-all;
    font-size: 14px;
    background-color: #f0f0f0;
    border-radius: 6px;
    padding: 12px;
    height: 70px;

    text-overflow: ellipsis;
  }
  .integration-status {
    font-size: 14px;
  }
}
</style>

<style lang="scss">
#integrationsHRIS .input-select .text-dropdown {
  width: 265px;
  font-size: 18px;
  color: #4a4a4a;
}
#integrationsHRIS .input-select > .el-submenu,
#integrationsHRIS .input-select .el-submenu__title,
#integrationsHRIS .input .el-input__inner,
#integrationsHRIS .el-button.refersh {
  height: 52px !important;
}
#integrationsHRIS .input-select > .el-submenu,
#integrationsHRIS .input-select .el-submenu__title {
  line-height: 52px !important;
}
#integrationsHRIS .el-radio-group {
  display: table-caption;
  .el-radio {
    .el-radio__inner {
      width: 24px;
      height: 24px;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #6c30cc;
      background: #6c30cc;
      &::after {
        transform: translate(-50%, -50%) scale(2);
      }
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #3b3b3b;
    }
    .el-radio__label {
      padding-left: 16px;
    }
  }
}
#integrationsHRIS .el-checkbox {
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    &:after {
      height: 9px;
      left: 5px;
    }
  }
  .el-checkbox__label {
    font-size: 18px;
    color: #3b3b3b;
  }
}
#integrationsHRIS .el-button.refersh {
  border-color: #c7c7c7;
  background-color: #f7f7f7;
  font-size: 24px;
  padding-left: 13px;
  padding-right: 18px;
  color: #000;
  margin-left: 12px;
  width: 52px;
}
#integrationsHRIS .input .el-input__inner {
  color: #3b3b3b;
  font-size: 18px;
  background-color: #f7f7f7;
  border-color: #c7c7c7;
  &:focus {
    border-color: #6c30cc;
  }
}
#integrationsHRIS .input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  &:focus {
    border-color: #e4e7ed;
  }
}
#integrationsHRIS .el-button {
  border-radius: 3px;
  width: 160px;
}
#integrationsHRIS .el-button.save {
  margin-left: 0;
  font-weight: 700;
  font-size: 18px;
  height: 52px;
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #fff;
}
#integrationStutus .el-button.btn-gray-outline {
  font-size: 15px;
  height: 42px;
}
#simulateChangesModal {
  .el-dialog {
    width: 1100px;
    height: 860px;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 40px;
    }
  }
  .el-table__row {
    margin-top: 6px;
    .cell {
      margin-top: 3px;
    }
  }
  .el-table th > .cell {
    font-weight: 700;
  }
}
#viewChangesModal {
  .el-dialog {
    width: 1100px;
    height: 860px;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 40px;
    }
  }
  .el-table__row {
    margin-top: 6px;
    .cell {
      margin-top: 3px;
    }
  }
  .el-table th > .cell {
    font-weight: 700;
  }
}
</style>
